import { inject, type InjectionKey } from 'vue';

export type ConnectPermissionMode = 'all' | 'any';

/** The shell's effective-permission check, handed to hosted apps through provide/inject. */
export interface ConnectPermissionAccess {
  can(requirement: string | readonly string[], mode?: ConnectPermissionMode): boolean;
}

export const ConnectPermissionsKey: InjectionKey<ConnectPermissionAccess> =
  Symbol('ConnectPermissions');

const denyAll: ConnectPermissionAccess = { can: () => false };

/** The permission check the Connect root provides; denies everything outside the shell. */
export function useConnectPermissions(): ConnectPermissionAccess {
  return inject(ConnectPermissionsKey, denyAll);
}
